export enum TerrainLoadingStatus {
  None                     = "None",
  Calculating              = "Calculating",
  Downloading              = "Downloading",
  Uploading                = "Uploading",
  FailedOnUpload           = "FailedOnUpload",
  FailedOnDownload         = "FailedOnDownload",
  FailedOnCheckingStatus   = "FailedOnCheckingStatus",
  Done                     = "Done",
}

export namespace TerrainLoadingStatus {
  // group all the “failure” values in one place
  const _failureSet: Set<TerrainLoadingStatus> = new Set<TerrainLoadingStatus>([
    TerrainLoadingStatus.FailedOnUpload,
    TerrainLoadingStatus.FailedOnDownload,
    TerrainLoadingStatus.FailedOnCheckingStatus,
  ]);

  /**
   * @returns true if this status is one of the three failures
   */
  export function isFailure(status: TerrainLoadingStatus): boolean {
    return _failureSet.has(status);
  }

  /**
   * @returns true if we’re in the “active” loading states
   */
  export function isLoading(status: TerrainLoadingStatus): boolean {
    return (
      status === TerrainLoadingStatus.Calculating ||
      status === TerrainLoadingStatus.Downloading ||
      status === TerrainLoadingStatus.Uploading
    );
  }

  /**
   * @returns true if we’re finished (either success “Done” or any failure)
   */
  export function isDone(status: TerrainLoadingStatus): boolean {
    return status === TerrainLoadingStatus.Done || isFailure(status);
  }
}
